<template>
  <div class="lib__form__announcement" v-if="!!apiErrors">
    <template v-for="(error, name) in apiErrors">
      <h2 :key="name" :class="isAlert ? 'lib__text-alert' : 'lib__text-danger'">
        <i class="far fa-times-circle"></i>
        {{ isSessionExpired ? $t("common.error.sessionExpired") : $t("common.error.title") }}
      </h2>
      <p :key="`${name}-${index}`" v-for="(message, index) in error" v-html="message"></p>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { ApiErrorNotification } from '@/models/api-error-notification'

@Component
export default class ApiErrors extends Vue {
  //#region [Data]
  @State('apiErrors', { namespace: 'apiErrors' })
  public readonly apiErrors!: ApiErrorNotification | null
  //#endregion

  //#region [Computed]
  public get isSessionExpired(): boolean {
    return this.apiErrors?.isSessionExpired !== undefined
  }

  public get isAlert(): boolean {
    return this.apiErrors?.isSessionExpired !== undefined
  }
  //#endregion
}
</script>